/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Field_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Short explanation for this pattern" |
*
* @param {Compliance_Template_Field_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_field_description_placeholder = /** @type {((inputs?: Compliance_Template_Field_Description_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Field_Description_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurze Erklärung für dieses Muster")
	return /** @type {LocalizedString} */ ("Short explanation for this pattern")
});